/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * The source of the payment
 */
export type PaymentUseCase =
  (typeof PaymentUseCase)[keyof typeof PaymentUseCase]

export const PaymentUseCase = {
  SOLAR: "SOLAR",
  WEBSITE: "WEBSITE",
  ELECTRIC_VEHICLE: "ELECTRIC_VEHICLE",
  MOTO: "MOTO",
} as const
